import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import moment from 'moment-timezone';
import MemberSelector from './MemberSelector';
import AABenefits from "./BenefitPlan/AA-Benefits";
import HRBenefits from "./BenefitPlan/HR-Benefits";

/**
 * Container component for the pharmacy page.
 * 
 */
class Benefits extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: true,
            copays: { InNetwork: null, OutOfNetwork: null },
            shouldRetrieveData: true,
            longestFootnote: null,
            currentPlan: null,
            showLeftNavArrow: false,
            showRightNavArrow: false,
            initialized: false,
            document: null,
            modalVisible: false,
            downloadingDocument: false
        };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.BenefitsPlan.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        if (this.props.AA) return (<AABenefits></AABenefits>);
        if (this.props.HR || this.props.swhp) return (<HRBenefits></HRBenefits>);
        return ("");
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        AA: state.domain.aai,
        HR: state.domain.hri, 
        swhp: state.domain.hi,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Benefits));
